<div id="strength">
    <b>{{ 'REGISTRATION.PASSWORD_STRENGTH' | translate:locale.language }}:</b>
    <ul id="strengthBar">
        <li class="point" [style.background-color]="bar0"></li><li class="point" [style.background-color]="bar1"></li><li class="point" [style.background-color]="bar2"></li><li class="point" [style.background-color]="bar3"></li><li class="point" [style.background-color]="bar4"></li>
    </ul>
</div>
